module.exports = __webpack_public_path__ + "img/brightpoint_icon_active_1.699482cd.png";